const GLOBAL_IMG =
  "https://images.unsplash.com/photo-1617729042101-e1333395d11e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxzaWx2ZXJzdG9uZSUyMHJhY2UlMjB0cmFja3xlbnwwfHx8fDE3OTA0NTA1MTR8MA&ixlib=rb-4.1.0&q=85";

const locations = [
  { name: "Monaco", testid: "global-location-monaco" },
  { name: "Silverstone", testid: "global-location-silverstone" },
  { name: "Miami", testid: "global-location-miami" },
  { name: "Las Vegas", testid: "global-location-vegas" },
  { name: "Premier League", testid: "global-location-premier-league" },
  { name: "European Football", testid: "global-location-europe" },
  { name: "Global Motorsport", testid: "global-location-motorsport" },
];

export default function GlobalSport() {
  return (
    <section id="global" className="relative min-h-[80vh] flex items-center overflow-hidden grain">
      <img
        src={GLOBAL_IMG}
        alt="Silverstone circuit gantry floodlit at night"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/65" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-28 w-full">
        <p className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#F7F6F2] mb-6">
          05 — Global Sport
        </p>
        <h2 className="font-heading font-light uppercase tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-7xl max-w-4xl">
          Built around the world's biggest sporting moments<span className="text-[#F7F6F2]">.</span>
        </h2>

        <div className="mt-14 flex flex-wrap gap-x-8 gap-y-4">
          {locations.map((l) => (
            <span
              key={l.name}
              data-testid={l.testid}
              className="flex items-center gap-3 font-mono-tech text-xs sm:text-sm uppercase tracking-[0.2em] text-neutral-300"
            >
              <span className="w-1.5 h-1.5 bg-[#F7F6F2]" />
              {l.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
